/**
 * Extracts the msal token from cookies.
 * @returns token combined from msal-token-{i} cookies or an
 * empty string if no token is found.
 */

export const extractMsalTokenFromCookie = (): string => {
  let i = 1;
  let msalToken = "";
  let tmpMsalToken = "";

  do {
    tmpMsalToken = getCookie(`msal-token-${i}`);

    if (tmpMsalToken !== "") {
      msalToken = msalToken.concat(tmpMsalToken);
    }

    i++;
  } while (tmpMsalToken !== "");

  return msalToken;
};

export const isMsalCookiePresent = (): boolean => {
  return getCookie("msal-token-1") !== "";
};

const getCookie = (name: string): string => {
  const ca: string[] = document.cookie.split(";");
  const caLen: number = ca.length;
  const cookieName = `${name}=`;
  let c: string;

  for (let i = 0; i < caLen; i += 1) {
    c = ca[i].replace(/^\s+/g, "");
    if (c.startsWith(cookieName)) {
      return c.substring(cookieName.length, c.length);
    }
  }

  return "";
};
